'use client';

import { c as _c } from "react/compiler-runtime";
import type { AwardHistory as AwardHistoryType } from '@shared/all/domains/award';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useUser from '@shared/utils/hooks/useUser';
import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import { animDelay } from '../../utils/animDelay';
import { client } from '../../utils/trpc';
import { useAuthModals } from '../../widgets/WidgetsContext';
import Error from '../common/Error';
const AwardHistory = () => {
  const $ = _c(15);
  const {
    currentUser
  } = useUser();
  const {
    openAuthContinueModal
  } = useAuthModals();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["awardHistory"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = currentUser.isAuthenticated === true;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: _temp,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    isLoading,
    data,
    error
  } = useQuery(t2);
  let t3;
  if ($[3] !== currentUser.isAuthenticated || $[4] !== data || $[5] !== error || $[6] !== isLoading || $[7] !== openAuthContinueModal) {
    t3 = currentUser.isAuthenticated ? <>{!isLoading && !error && data?.history && data.history.length > 0 && <div className="anim-enter overflow-hidden rounded-xl border border-ds-border-standard bg-background-secondary shadow-md [--enter-duration:400ms] [--enter-y:20px]"><table className="anim-enter w-full"><thead className="bg-background-secondary"><tr className="text-left text-sm text-textSecondary"><th className="px-4 py-3 font-emphasis">Date</th><th className="px-4 py-3 font-emphasis">Type</th><th className="px-4 py-3 font-emphasis">Award</th><th className="px-4 py-3 font-emphasis">Trons</th><th className="px-4 py-3 font-emphasis">Visibility</th><th className="px-4 py-3 font-emphasis">Post</th></tr></thead><tbody className="divide-y divide-ds-border-subtle">{data?.history.map(_temp2)}</tbody></table></div>}{data?.history.length === 0 && <div className="anim-enter flex h-40 w-full items-center justify-center rounded-xl border border-ds-border-standard bg-background-secondary p-8 text-center shadow-md [--enter-duration:400ms] [--enter-y:20px]"><p className="text-textSecondary">No awards sent or received yet.</p></div>}</> : <div className="anim-enter mb-10 [--enter-duration:400ms] [--enter-y:20px]"><h2 className="mb-4 text-2xl font-semibold text-textPrimary">Award History</h2><div className="overflow-hidden rounded-xl border border-ds-border-standard shadow-sm"><div className="px-4 py-6 text-center text-textSecondary">Please{" "}<button className="text-primary" onClick={openAuthContinueModal}>log in</button>{" "}to view your award history.</div></div></div>;
    $[3] = currentUser.isAuthenticated;
    $[4] = data;
    $[5] = error;
    $[6] = isLoading;
    $[7] = openAuthContinueModal;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = Boolean(error);
  let t5;
  if ($[9] !== isLoading || $[10] !== t4) {
    t5 = <Error loading={isLoading} error={t4} />;
    $[9] = isLoading;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="anim-enter w-full p-4 [--enter-duration:500ms]">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default AwardHistory;
function _temp() {
  return unwrapFromResult(client.awards.history.query());
}
function _temp2(x, i) {
  return <tr key={i + 1} style={animDelay(i * 50)} className="anim-enter text-sm text-textPrimary transition-colors [--enter-y:20px] hover:bg-background-light/20"><td className="px-4 py-3"><div className="flex flex-col"><span className="font-emphasis text-textPrimary">{new Date(x.date).toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric"
          })}</span><span className="text-xs text-textSecondary">{new Date(x.date).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit"
          })}</span></div></td><td className="px-4 py-3">{x.type}</td><td className="px-4 py-3 font-emphasis">{x.awardName}</td><td className="px-4 py-3 font-emphasis">{x.quantity.toLocaleString()}</td><td className="px-4 py-3"><span className={`inline-flex rounded-full px-2 py-1 text-xs font-emphasis ${x.private ? "bg-background-secondary text-textSecondary" : "bg-primary/10 text-primary"}`}>{x.private ? "Anonymous" : "Public"}</span></td><td className="px-4 py-3"><div className="transition-transform duration-200 hover:scale-[1.05] active:scale-[0.95]"><Link href={`/post/${x.postUuid}`} className="inline-flex rounded-md px-3 py-1 text-primary transition-all duration-200 hover:bg-primary/10">View Post</Link></div></td></tr>;
}